import classNames from 'classnames';
import React, { FC } from 'react';
import ReactModal from 'react-modal';
import styles from './modal_confirmation_container.module.scss';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  className?: string;
  overlayClassName?: string;
  shouldCloseOnOverlayClick?: boolean;
  'data-test-id'?: string;
};

export const ModalConfirmationContainer: FC<Props> = ({
  isOpen,
  onRequestClose,
  className = '',
  overlayClassName = '',
  children,
  shouldCloseOnOverlayClick = true,
  ...props
}) => {
  const customProps = {
    className: classNames(className, 'react-modal', styles.container),
    overlayClassName: classNames(
      overlayClassName,
      'react-modal__overlay',
      styles.overlay,
    ),
    isOpen,
    ariaHideApp: false,
    shouldCloseOnOverlayClick,
    onRequestClose,
    data: { 'test-id': props['data-test-id'] },
  };

  return <ReactModal {...customProps}>{children}</ReactModal>;
};
